module.exports = __webpack_public_path__ + "img/s7edge.39e3f799.jpg";